import {Color} from '@benchling/nucleus-ui';
import {ElkEdgeSection} from 'elkjs';
import {EdgeProps} from 'reactflow';

import {EdgeStatus} from '../nodes/BenchlingNode/v2/BenchlingNodeV2Constants';

export enum LineStyle {
  SOLID = 'SOLID',
  DASHED = 'DASHED',
}

export enum EdgeType {
  BEZIER = 'BEZIER',
  ELK_SPLINE = 'ELK_SPLINE',
}
export interface BaseEdgeRendererData {
  color?: string;
  lineStyle?: LineStyle;
  status?: EdgeStatus;
}
export interface BezierEdgeRendererData extends BaseEdgeRendererData {
  type: EdgeType.BEZIER;
}

export interface ElkSplineEdgeRendererData extends BaseEdgeRendererData {
  type: EdgeType.ELK_SPLINE;
  elkEdgeSections: Array<ElkEdgeSection>;
}

export type BezierEdgeProps = EdgeProps<BezierEdgeRendererData>;
export type ElkSplineEdgeProps = EdgeProps<ElkSplineEdgeRendererData>;
export type BenchlingEdgeProps = BezierEdgeProps | ElkSplineEdgeProps;

export const DEFAULT_EDGE_OPTIONS = {
  color: Color.GRAY_400,
  lineStyle: LineStyle.SOLID,
};
